 <!-- skeleton -->
 <ng-template #loadingSkeleton>
   <nz-skeleton class="bg-white dark:bg-white/10 rounded-6 p-[30px] pt-[15px]" [nzShape]="circle" [nzActive]="true"
     [nzParagraph]="{ rows: 7}"></nz-skeleton>
 </ng-template>
 <!-- skeleton -->
  <div nz-col nzXs="24" nzMd="12">
    <ng-template #newContactContent>
      <form nz-form nzLayout="vertical">
        <nz-form-item>
          <nz-form-control>
            <nz-form-label class="text-[15px] font-semibold text-dark dark:text-white/[.87] capitalize mb-[10px]">Name:</nz-form-label>
            <input class="h-[50px] border-normal dark:border-white/10 px-[20px] placeholder-shown:text-light-extra dark:placeholder-shown:text-white/60 rounded-[5px] dark:bg-white/10" type="text" nz-input placeholder="Input Name">
          </nz-form-control>
        </nz-form-item>
        <nz-form-item>
          <nz-form-control>
            <nz-form-label class="text-[15px] font-semibold text-dark dark:text-white/[.87] capitalize mb-[10px]">Email address:</nz-form-label>
            <input class="h-[50px] border-normal dark:border-white/10 px-[20px] placeholder-shown:text-light-extra dark:placeholder-shown:text-white/60 rounded-[5px] dark:bg-white/10" type="email" nz-input placeholder="name@example.com">
          </nz-form-control>
        </nz-form-item>
        <nz-form-item>
          <nz-form-control>
            <nz-form-label class="text-[15px] font-semibold text-dark dark:text-white/[.87] capitalize mb-[10px]">Phone Number:</nz-form-label>
            <input class="h-[50px] border-normal dark:border-white/10 px-[20px] placeholder-shown:text-light-extra dark:placeholder-shown:text-white/60 rounded-[5px] dark:bg-white/10" type="email" nz-input placeholder="+440 2546 5236">
          </nz-form-control>
        </nz-form-item>
        <nz-form-item>
          <nz-form-control>
            <nz-form-label class="text-[15px] font-semibold text-dark dark:text-white/[.87] capitalize mb-[10px]">Position:</nz-form-label>
            <input class="h-[50px] border-normal dark:border-white/10 px-[20px] placeholder-shown:text-light-extra dark:placeholder-shown:text-white/60 rounded-[5px] dark:bg-white/10" type="email" nz-input placeholder="Input Position">
          </nz-form-control>
        </nz-form-item>
        <nz-form-item class="mb-0">
          <nz-form-control>
            <nz-form-label class="text-[15px] font-semibold text-dark dark:text-white/[.87] capitalize mb-[10px]">Company Name:</nz-form-label>
            <input class="h-[50px] border-normal dark:border-white/10 px-[20px] placeholder-shown:text-light-extra dark:placeholder-shown:text-white/60 rounded-[5px] dark:bg-white/10" type="email" nz-input placeholder="Company Name">
          </nz-form-control>
        </nz-form-item>
      </form>
    </ng-template>
    <!-- :End New project added -->
  </div>

  <div nz-row nzGutter="25" class="mt-[4px]">
   <div nz-col nzXs="24" nzMd="12" class="mb-[25px]">
    <div class="flex items-center flex-wrap gap-[20px]  max-lg:justify-center">
      <!-- Search Box -->
      <h1 class="text-dark dark:text-white/[.87] text-[22px] font-semibold mb-0">Contacts</h1>
      <div class="3xl:w-[280px] max-ssm:w-full [&>div>div.ant-select-selector]:border-0">
        <nz-input-group class="bg-white dark:bg-white/10 rounded-[6px] h-[40px] flex items-center px-[20px]">
          <input class="bg-transparent border-none text-[15px] shadow-none text-dark dark:text-white/[.87] flex items-center" type="text" nz-input
            placeholder="Search contacts" [(ngModel)]="searchInput" (ngModelChange)="search()">
          <i class="text-theme-gray dark:text-white/[.87]" nz-icon nzType="search"></i>
        </nz-input-group>
      </div>
      <!-- :End Search Box -->
    </div>
   </div>
   <div nz-col nzXs="24" nzMd="12" class="mb-[25px]">
     <!-- New Contact -->
     <div class="flex items-center justify-center md:justify-end">
      <button class="flex items-center px-[14px] text-sm text-white rounded-md font-semibold bg-primary border-primary h-10 gap-[6px]" nz-button (click)="showNewContact(newContactContent)">
        <i class="text-[12px]" nz-icon nzType="plus"></i>
        <span class="m-0">Add New</span>
      </button>
    </div>
      <!-- end: New Contact -->
   </div>
 </div>
 <div nz-row nzGutter="25">
  <div nz-col nzXs="24" nzSm="12" nzXl="8" nzXXl="6" class="mb-[25px]" *ngFor="let item of ContactGrid">
    <ng-container *ngIf="showContent; else loadingSkeleton">
      <div class="bg-white dark:bg-white/10 shadow-[0_5px_20px_rgba(173,181,217,0.01)] p-[25px] rounded-10 relative">
        <figure class="m-0 text-center">
          <img class="inline-block rounded-full w-[120px] h-[120px]" src="assets/images/avatars/{{item.avatar}}" alt="img">
          <figcaption class="mt-[20px]">
            <h3 class="text-[18px] font-semibold mb-0 text-dark dark:text-white/[.87]">{{item.name}}</h3>
            <span class="text-[#8288a4] dark:text-white/60 text-[14px]">{{item.rule}}</span>
          </figcaption>
        </figure>
        <div class="mt-[20px] dark:border-white/10 border-t-1 pt-[25px] border-regular" *ngIf="item.user.length > 0">
          <ul class="flex flex-col flex-wrap gap-[14px]">
            <li *ngFor="let item of item.user">
              <div  class="flex items-center text-[#8288a4] dark:text-white/60 gap-[12px] text-[14px] capitalize" *ngIf="item.type == 'call'">
                <span class="text-light dark:text-white/60" nz-icon nzType="{{item.icon}}" nzTheme="outline"></span>
                {{item.name}}
              </div>
              <div  class="flex items-center text-[#8288a4] dark:text-white/60 gap-[12px] text-[14px] capitalize" *ngIf="item.type == 'mail'">
                <span class="text-light dark:text-white/60" nz-icon nzType="{{item.icon}}" nzTheme="outline"></span>
              {{item.name}}
              </div>
              <div  class="flex items-center text-[#8288a4] dark:text-white/60 gap-[12px] text-[14px] capitalize" *ngIf="item.type == 'skype'">
                <span class="text-light dark:text-white/60" nz-icon nzType="{{item.icon}}" nzTheme="outline"></span>
              {{item.name}}
              </div>
              <div  class="flex items-center text-[#8288a4] dark:text-white/60 gap-[12px] text-[14px] capitalize" *ngIf="item.type == 'map'">
                <svg-icon class="[&>svg]:w-[14px] [&>svg]:h-[14px] text-light dark:text-white/60"
                  src="assets/images/svg/feather/{{item.icon}}.svg"></svg-icon>
                  {{item.name}}
              </div>
            </li>
            </ul>
            </div>
            <button nz-button class="bg-transparent border-none absolute top-[16px] text-light dark:text-white/60 ltr:right-[26px] rtl:left-[26px] inline-flex items-center justify-center p-0" nz-dropdown nzTrigger="click" [nzDropdownMenu]="menu">
              <svg-icon
                class=" text-light-extra dark:text-white/60 dark:group-hover:text-white/[.87] w-[24px] h-[24px] [&>svg]:w-[24px] [&>svg]:h-[24px]"
                src="assets/images/svg/feather/more-horizontal.svg"></svg-icon>
            </button>
            <nz-dropdown-menu #menu="nzDropdownMenu">
              <ul
                class="block bg-white dark:bg-[#1b1e2b] shadow-regular dark:shadow-[0_5px_30px_rgba(1,4,19,.60)] rounded-4 capitalize"
                nzSelectable>
                <li
                  class="flex items-center text-theme-gray dark:text-white/60 hover:bg-primary/10 hover:text-primary dark:hover:bg-white/10 px-3 py-1.5 text-sm dark:hover:text-white/[.87]"
                  >
                  view
                </li>
                <li
                  class="flex items-center text-theme-gray dark:text-white/60 hover:bg-primary/10 hover:text-primary dark:hover:bg-white/10 px-3 py-1.5 text-sm dark:hover:text-white/[.87]"
                  >
                  edit
                </li>
                <li
                  class="flex items-center text-theme-gray dark:text-white/60 hover:bg-primary/10 hover:text-primary dark:hover:bg-white/10 px-3 py-1.5 text-sm dark:hover:text-white/[.87]"
                  >
                  delete
                </li>
              </ul>
            </nz-dropdown-menu>
          </div>
    </ng-container>
  </div>
 </div>
